import { useIsAuthorized } from '@modules/common/components/CanAccess/hooks';
import { useFetchTenantAutoApprovalState } from '@modules/users/hooks';
import { useFetchUsers } from '@modules/users/hooks/useFetchUsers';
import { Stack } from '@mui/material';
import { PermissionOperation, PermissionResource } from 'generated/graphql';
import { Navigate } from 'react-router-dom';
import { WorkspaceSettingsBody } from '../WorkspaceSettingsBody';
import WorkspaceSettingsHeader from './WorkspaceSettingsHeader';

interface WorkspaceSettingsProps {
  isOnboardingPageVariant?: boolean;
}

export const WorkspaceSettings = ({
  isOnboardingPageVariant = false,
}: WorkspaceSettingsProps) => {
  const canAccessWorkspaceSettings = useIsAuthorized({
    resource: PermissionResource.WorkspaceSettings,
    operation: PermissionOperation.Write,
  });

  const shouldSkipAPICalls = !canAccessWorkspaceSettings;

  useFetchUsers({
    skip: shouldSkipAPICalls,
  });

  useFetchTenantAutoApprovalState({
    skip: shouldSkipAPICalls,
  });

  if (!canAccessWorkspaceSettings) {
    return <Navigate replace to="/" />;
  }

  return (
    <Stack>
      <WorkspaceSettingsHeader
        isOnboardingPageVariant={isOnboardingPageVariant}
      />
      <WorkspaceSettingsBody
        isOnboardingPageVariant={isOnboardingPageVariant}
      />
    </Stack>
  );
};
